import { FC } from 'react';
import {
  Box,
  Button,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
} from '@chakra-ui/react';
import { FormState, UseFormRegister } from 'react-hook-form';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import {
  ChannelForm,
  CorporateNumberForm,
  DetailForm,
  EnvironmentForm,
  NameForm,
  SystemUpdateGroupForm,
  IapClientIdForm,
  IapClientSecretForm,
  PoseidonUrlForm,
  PoseidonAgentCpuForm,
  PoseidonAgentMemoryForm,
  EnableVerticalPodAutoScalerForm,
} from 'page/CustomerPage/components/Forms/RegistrationForms';
import { Channel } from 'types/customer';

type Props = {
  watchChannel: Channel;
  watchEnableVerticalPodAutoScaler: boolean;
  formState: FormState<CustomerFormFields>;
  isOpen: boolean;
  isButtonDisabled: boolean;
  register: UseFormRegister<CustomerFormFields>;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModalView: FC<Props> = ({
  watchChannel,
  watchEnableVerticalPodAutoScaler,
  formState,
  isOpen,
  isButtonDisabled,
  register,
  handleClose,
  handleClickGoConfirmation,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="2xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent h="90vh">
      <ModalHeader p="40px 40px 0 40px">顧客情報の登録</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {/* 顧客名 */}
        <Box mt="40px">
          <NameForm register={register} error={formState.errors.name} />
        </Box>
        {/* 顧客詳細 */}
        <Box mt="40px">
          <DetailForm register={register} error={formState.errors.detail} />
        </Box>
        {/* GCP プロジェクト名 */}
        <Box mt="40px">
          <EnvironmentForm
            register={register}
            error={formState.errors.environment}
          />
        </Box>
        {/* 顧客番号 */}
        <Box mt="40px">
          <CorporateNumberForm
            register={register}
            error={formState.errors.corporateNumber}
          />
        </Box>
        {/* 契約種別 */}
        <Box mt="40px">
          <ChannelForm
            register={register}
            watchChannel={watchChannel}
            error={formState.errors.channel}
          />
        </Box>
        {/* 顧客環境URL */}
        <Box mt="40px">
          <PoseidonUrlForm
            register={register}
            error={formState.errors.poseidonUrl}
          />
        </Box>
        {/* システム管理上のグループ */}
        <Box mt="40px">
          <SystemUpdateGroupForm
            register={register}
            error={formState.errors.systemUpdateGroup}
          />
        </Box>
        {/* IAP */}
        <Box mt="40px">
          <SimpleGrid templateColumns="1fr 2fr">
            <FormLabel>IAP</FormLabel>
          </SimpleGrid>
        </Box>
        {/* IAP Client ID */}
        <Box mt="20px">
          <IapClientIdForm
            register={register}
            error={formState.errors.iapClientId}
          />
        </Box>
        {/* IAP Client Secret */}
        <Box mt="20px">
          <IapClientSecretForm
            register={register}
            error={formState.errors.iapClientSecret}
          />
        </Box>
        {/* Poseidon設定 */}
        <Box mt="40px">
          <SimpleGrid templateColumns="1fr 2fr">
            <FormLabel>Poseidon設定</FormLabel>
          </SimpleGrid>
        </Box>
        {/* Poseidon Agent CPU */}
        <Box mt="20px">
          <PoseidonAgentCpuForm
            register={register}
            error={formState.errors.poseidonAgentCpu}
          />
        </Box>
        {/* Poseidon Agent Memory */}
        <Box mt="20px">
          <PoseidonAgentMemoryForm
            register={register}
            error={formState.errors.poseidonAgentMemory}
          />
        </Box>
        {/* VPA設定 */}
        <Box mt="20px">
          <EnableVerticalPodAutoScalerForm
            register={register}
            error={formState.errors.enableVerticalPodAutoScaler}
            watchEnableVerticalPodAutoScaler={watchEnableVerticalPodAutoScaler}
          />
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" mt="20px" mb="20px">
        <Button
          width="140px"
          colorScheme="blackAlpha"
          mr={3}
          onClick={handleClickGoConfirmation}
          isDisabled={isButtonDisabled}
        >
          確認
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
